module.exports = __webpack_public_path__ + "img/bg-frame.4c104400.png";